/**
 * UGC Single Play
 * Ensures only one video plays at a time - pauses others when one starts playing
 */

document.addEventListener('DOMContentLoaded', () => {
  const ugcVideos = document.querySelectorAll('.ugc-card__media--video video');
  
  // Listen to play event on each video
  ugcVideos.forEach((video) => {
    video.addEventListener('play', () => {
      // Pause all other videos
      ugcVideos.forEach((otherVideo) => {
        if (otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
          
          // Update the paused video's button state
          const ugcCard = otherVideo.closest('ugc-card');
          if (ugcCard) {
            const playBtn = ugcCard.querySelector('.ugc-card__play-btn');
            if (playBtn) {
              playBtn.dataset.playing = 'false';
              
              const pauseIcon = playBtn.querySelector('.ugc-card__icon--pause');
              const playIcon = playBtn.querySelector('.ugc-card__icon--play');
              
              if (pauseIcon && playIcon) {
                pauseIcon.style.display = 'none';
                playIcon.style.display = 'block';
                playBtn.setAttribute('aria-label', 'Play');
              }
            }
          }
        }
      });
    });
  });
});
